import { useCreateFilterButtons, type IFilterButtonsResult, type IFilterItem } from '@/creditflowresearch/ui/common/hooks/filters/useCreateFilterButtons';
import { useRegionState } from '@/creditflowresearch/ui/common/hooks/regions/useRegionState';
import Region from '@/creditflowresearch/domain/Region';
import { hasRegionAccess, type IRegionAccessControl } from '@/creditflowresearch/domain/Region/selectors/hasRegionAccess';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';

export const useRegionFilters = (preferredRegionIds?: string[]): IFilterButtonsResult => {
  const regionState = useRegionState(preferredRegionIds);
  const { regionsList, selectedRegionId, accessControl } = regionState;

  return useCreateFilterButtons<IFilterItem>(
    regionsList,
    selectedRegionId,
    regionState.setSelectedRegionId,
    {
      hasAccessCheck: (region) => hasRegionAccess(region.id, accessControl as IRegionAccessControl),
      getTooltip: (region) => `Includes deals issued with currencies or issuers domiciled in ${ region.name }`,
      getIsActive: (region, selected) => {
        const hasAccess = UserPlan.isSatisfiedPremiumPlan(accessControl.plan);
        return hasAccess
          ? selected === region.id
          : region.id === Region.USOA_ID;
      },
    },
  );
};
